import React, { useState, memo, useEffect, useRef } from "react";
import { Card, Col, List, Row, Skeleton, Slider, Space } from "antd";
import Meta from "antd/es/card/Meta";

import {
  DropDown,
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import styles from "./vendors.module.css";

import img1 from "../../../../assets/staticImages/photoimg1.png";
import img2 from "../../../../assets/staticImages/photoimg2.png";
import img3 from "../../../../assets/staticImages/photoimg3.png";
import img4 from "../../../../assets/staticImages/photoimg4.png";
import img5 from "../../../../assets/staticImages/companyImg.png";
import dummyImg from "../../../../assets/dummy.jpg";
import { AiFillStar } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { VendorMiddleware } from "../../../../Store/Middlewares/VendorMiddleware";
import { BsFillFilterSquareFill } from "react-icons/bs";
import Modal from "../../../../components/modal/Modal";
import { GoDotFill } from "react-icons/go";
import Autocomplete from "react-google-autocomplete";
import { API_KEY, GOOGLE_MAPS_APIKEY } from "../../../../config/Apis";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { RequestType, geocode, setKey, setLanguage } from "react-geocode";
import { useGeolocated } from "react-geolocated";
import { CurrentLocation } from "../../../../config/CurrentLocation";
import AutoCompleteInput from "../../../../components/auntoCompleteInput/AutoCompleteInput";

const RenderItem = memo(({ item, loader }) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  return (
    <List.Item
      onClick={() => {
        navigate("/findVendors/VendorDetails", {
          state: {
            headrTitle: item?.service_category_name ? item?.service_category_name : "",
            data: item,
            eventData: state?.eventData,
          },
        });
      }}
    >
      {loader ? (
        <Space
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            marginTop: "10px",
          }}
        >
          <Skeleton.Image active className={styles.image} />
          <Skeleton.Input active size={20} />
        </Space>
      ) : (
        <Card
          hoverable
          style={{ width: "100%", textAlign: "center", alignItems: "center" }}
          cover={
            <img
              className={styles.image}
              src={item.image ? item.image : dummyImg}
              alt="example"
            />
          }
        >
          <Meta
            style={{ textAlign: "center" }}
            title={
              <>
                <TextComponent
                  text={item?.name}
                  // textClass={styles.nameText}
                />
              </>
            }
            // description={<TextComponent text={item.des} />}
          />

          {/* <Row className={styles.avenueText}>
            <TextComponent
              textClass={styles.avenueText}
              text={item?.distance}
            />
          </Row> */}
          <TextComponent
            textClass={styles.descText}
            text={item.address ? item.address : "--"}
          />
          <Row className={styles.ratingCont}>
            <TextComponent text={item.rating_count?.toFixed(1)} />
            <AiFillStar color="#FFD600" size={20} />
          </Row>
        </Card>
      )}
    </List.Item>
  );
});

const IndividulVendors = () => {
  const { state } = useLocation();
  const [search, setSearch] = useState("");
  const [miles, setMiles] = useState("");
  const [loader, setLoader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [distance, setDistance] = useState(1);
  const [latlng, setlatlng] = useState();
  const [currentLocation, setCurrentLocation] = useState();
  const [cords, setCords] = useState(null);
  let timeout = useRef(null);
  const dispatch = useDispatch();
  const findVendorByCat = useSelector(
    (state) => state.VendorReducer.findVendorByCat
  );
  const findVendorsPaginationByCat = useSelector(
    (state) => state.VendorReducer.findVendorsPaginationByCat
  );
  console.log("stateeeee===>>", state);
  const getData = (data = null) => {
    setLoader(true);
    dispatch(VendorMiddleware.findVendorsByCat(data))
      .then(() => {
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
      });
  };
  useEffect(() => {
    dispatch(CurrentLocation.getLiveLocation())
      .then((res) => {
        setlatlng(res);
      })
      .catch((err) => {
        console.log(err);
      });
    getData({
      category_id: state?.vendorData?.id,
    });
  }, []);

  const onLoadMore = () => {
    getData({
      category_id: state?.vendorData?.id,
      next_page_url: findVendorsPaginationByCat?.links?.next,
    });
  };
  const onSearch = (e) => {
    setSearch(e.target.value);
    setLoader(true);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      getData({
        category_id: state?.vendorData?.id,
        findVendor_name: e.target.value,
        next_page_url: findVendorsPaginationByCat?.links?.next,
      });
    }, 1500);
  };

  const onFilter = () => {
    getData({
      category_id: state?.vendorData?.id,
      findVendor_name: undefined,
      next_page_url: findVendorsPaginationByCat?.links?.next,
      distance: distance,
      address: currentLocation?.address ? currentLocation?.address : null,
      lat: currentLocation?.lat ? currentLocation?.lat : latlng?.latitude,
      lng: currentLocation?.lng ? currentLocation?.lng : latlng?.longitude,
    });
  };

  return (
    <>
      {/* <Row className={styles.searchContainer}>
        <Col className={styles.search}>
          <SearchInput
            className={styles.searchInput}
            placeholder={"Search"}
            onChange={(e) => setSearch(e)}
          />
        </Col>

        <Col className={styles.search}>
          <TextComponent text="In" textClass={styles.textinput} />
          <input className={styles.input} placeholder="New York" />
        </Col>
        <Col className={styles.search}>
          <TextComponent text="Miles" textClass={styles.textinput} />
          <input className={styles.input} placeholder="50" value={miles}  />
        </Col>
        <Col className={styles.category}>
          <SubmitButton title="Search" btnClass={styles.btnClass} />
        </Col>
      </Row> */}
      <SearchInput
        className={styles.searchInput}
        placeholder={"Search"}
        onChange={(e) => onSearch(e)}
        // rightIcon={
        //   <BsFillFilterSquareFill
        //     size={25}
        //     className={styles.filterIcon}
        //     onClick={() => setIsModalOpen(true)}
        //   />
        // }
      />
      <List
        className={styles.listClass}
        grid={{
          xs: 1,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 4,
          xxl: 4,
        }}
        dataSource={findVendorByCat}
        renderItem={(item) => <RenderItem item={item} loader={loader} />}
        footer={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {findVendorsPaginationByCat?.links?.next != null ? (
              <div style={{ width: "50%" }}>
                <SubmitButton title={"Load More"} onClick={onLoadMore} />
              </div>
            ) : null}
          </div>
        }
      />
      {/* <Modal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        closable={true}
        className={styles.modal}
      >
        <Row className={styles.modalCont}>
          <TextComponent text={"Filter"} textClass={styles.modalHeading} />
          <TextComponent text={"Distance"} textClass={styles.label} />
          <Row className={styles.distCont}>
            {[1, 500, 1000].map((item) => (
              <Col
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Row>
                  <TextComponent
                    text={`${item} Miles`}
                    textClass={`${styles.distText} ${
                      distance >= item ? styles.distTextActive : ""
                    }`}
                  />
                </Row>
                <Row>
                  <GoDotFill
                    size={20}
                    className={`${styles.dotIcon} ${
                      distance >= item ? styles.distTextActive : ""
                    }`}
                  />
                </Row>
              </Col>
            ))}
          </Row>
          <Slider
            defaultValue={1}
            min={1}
            max={1000}
            onChange={setDistance}
            trackStyle={{ backgroundColor: "var(--primary-color)" }}
          />

          <AutoCompleteInput
            label={"Location"}
            placeholder={"Enter Adress"}
            address={currentLocation?.adress}
            onSelectPlace={(place) => {
              let currentLocation = {
                lat: place?.geometry?.location?.lat(),
                lng: place?.geometry?.location?.lng(),
                address: place?.formatted_address,
              };
              setCurrentLocation(currentLocation);
            }}
          />

          <SubmitButton
            title="Search"
            btnClass={styles.modalbtnClass}
            onClick={onFilter}
          />
        </Row>
      </Modal> */}
    </>
  );
};

export default IndividulVendors;
